import React, { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import toast, { Toaster } from 'react-hot-toast';
import DatePicker, { registerLocale } from "react-datepicker";

import InputMask from 'react-input-mask';
import ru from "date-fns/locale/ru";
import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';
import { reducerEmployeeStatus } from '../../../redux/reducer/employees/reducers/employeesList';
import { reducerInputValuesProfile, reducerTest } from '../../../redux/reducer/employees/reducers/profileEmployee';

//import { formatDateWithDots } from '../../../utils/formatDate';
import { generateStyles } from '../../../utils/generateToastStyles';
import Select from '../../custom/select/select';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import Loader from '../../custom/loader/loader';
import ToastPopup from '../../custom/toastPopup/toastPopup';

import styles from './employees.module.scss';
import '../../table/table.scss';
import Accardion from '../../custom/accardion/accardion';
import TextArea from '../../custom/textArea/TextArea';
import InputNumber from '../../custom/numberInput/NumberInput';
import { IUserOptions } from '../../../types/interfaces';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const logOptions = [{ label: 'Да', value: 'true' }, { label: 'Нет', value: 'false' }];
const typeOptions = [{ label: 'Основная', value: 'main' }, { label: 'Техническая', value: 'tech' }];
/////
const createData = '2024.05.08 14:55:18';
///

const TableProfileEmplooyee: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id } = useParams<{ id: string }>();
  const isPending = false;

  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

  const {
    advertisingSources,
    advertisingCategories,
  } = useSelector((state: any) => state.recruiting?.singleApplication?.data);

  const { inputValues, inputTest } = useSelector((state: any) => state.employees.profileEmployees);
  const { employeeStatus } = useSelector((state: any) => state.employees?.employeesList);
  const { applicationErrors: errors } = useSelector((state: any) => state.recruiting?.singleApplication);

  const [isVisiblePhoto, setIsVisiblePhoto] = useState<boolean>(!!id);
  const [isVisibleScanMigration, setIsVisibleScanMigration] = useState<boolean>(!!id);
  const [isVisibleScanMed, setIsVisibleScanMed] = useState<boolean>(!!id);
  const [isVisibleScanPatent, setIsVisibleScanPatent] = useState<boolean>(!!id);
  const [isOpenDatePicker, setIsOpenDatePicker] = useState<string>('');

  const [isCheckboxesChecked, setIsCheckboxesChecked] = useState<boolean>(false);

  const requestStatusOptions = [
    {
      status: 2,
      successMessage: "Признак используется, когда работает один сотрудник, а получает другой. Укажите ФИО работающего сотрудника.",
    },
    {
      status: 3,
      successMessage: "Признак используется, когда работает один сотрудник, а получает оплату другой. Укажите ФИО работающего сотрудника.",
    },
    {
      status: 0,
      errorMessage: "Изменения в зарплате не могут быть применены раньше завтрашнего дня», если «Дата изменения» содержит дату раньше завтрашнего дня.",
    },
  ];

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsCheckboxesChecked(checked);
    if (checked) {
      dispatch(reducerEmployeeStatus(3));
    }
  };

  const selectChange = (event: { value: string | number, label: string }, name: string) => {
    dispatch(reducerInputValuesProfile({ ...inputValues, [name]: event }));
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    console.log(name, value);
  };

  useEffect(() => {
    requestStatusOptions.forEach((option: any) => {
      if (employeeStatus === option.status) {
        toast.dismiss();

        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false)
        );
      }
    });

    setTimeout(() => {
      dispatch(reducerEmployeeStatus(null));
    }, 5000);
    // eslint-disable-next-line
  }, [dispatch, employeeStatus]);

  useEffect(() => {
    registerLocale("ru", ru);
  }, []);

  return (
    <>
      <div className='loader__wrapper'>{isPending && <Loader />}</div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
          isOpenSidebar &&
          'active__table',
          !isOpenSidebar && 'closed__table',
          'vacancy_create_table', 'vacancy_create_tableEmployees'
        )}
      >
        {(employeeStatus && employeeStatus !== null) && <Toaster
          position='top-center'
          toastOptions={{
            duration: 5000,
          }}
        />}
        <div className={styles.tableWrapper}>
          <div className={styles.midSectionWrapper}>
            <div className={styles.halfBlock}>
              <div className={styles.vacancyBlock}>
                <Accardion
                  name='worker'
                  title='Работник'
                  children={<>
                    <div className={styles.container}>
                      <div className={styles.userProfile} >
                        {isVisiblePhoto &&
                          (<div className={styles.photo} >
                            <div className={clsx(styles.photo__container, styles.photo__container_main)} />
                            <button className={styles.photo__remove} onClick={() => setIsVisiblePhoto(false)}></button>
                          </div>)}
                      </div>
                      <div className={styles.fullName}>
                        <div className={clsx(
                          styles.subBlock,
                          styles.subBlock__right,
                          styles.filterInput,
                        )}
                          style={{ margin: "0" }}>
                          <div className={clsx(styles.filterInput, errors.includes('lastName') && styles.error)}>
                            <input
                              value={id && 'Иванов Виктор Петрович'}
                              onChange={handleInputChange}
                              name='lastName'
                              type='text'
                              placeholder=' '
                              disabled={true}
                            />
                            <label>ФИО</label>
                          </div>
                        </div>

                        <div>
                          <div className={clsx(
                            styles.subBlock,
                            styles.subBlock__right
                          )}>
                            <div className={clsx(styles.filterInput, errors.includes('lastName') && styles.error)}>
                              <input
                                defaultValue={id ? inputValues.surname : ''}
                                onChange={handleInputChange}
                                name='lastName'
                                type='text'
                                placeholder=' '
                              />
                              <label>Фамилия<span className={styles.changed}>*</span></label>
                            </div>
                          </div>
                          {id && (inputValues.surname.indexOf(' ') > 0 || inputValues.surname.lastIndexOf(' ') > 0) && <span className={styles.span__error}>Содержит пробел</span>}
                        </div>

                        <div>
                          <div className={clsx(
                            styles.subBlock,
                            styles.subBlock__right,
                            styles.filterInput
                          )}>
                            <div className={clsx(styles.filterInput, errors.includes('name') && styles.error)}>
                              <input
                                defaultValue={id ? inputValues.name : ''}
                                onChange={handleInputChange}
                                name='name'
                                type='text'
                                placeholder=' '
                              />
                              <label>Имя<span className={styles.changed}>*</span></label>
                            </div>
                          </div>
                          {(inputValues.name.indexOf(' ') > 0 || inputValues.name.lastIndexOf(' ') > 0) && <span className={styles.span__error}>Содержит пробел</span>}
                        </div>

                        <div>
                          <div className={clsx(
                            styles.subBlock,
                            styles.subBlock__right,
                            styles.filterInput
                          )}>
                            <div className={clsx(styles.filterInput)}>
                              <input
                                defaultValue={id ? inputValues.patronymic : ''}
                                onChange={handleInputChange}
                                name='patronymic'
                                type='text'
                                placeholder=' '
                              />
                              <label>Отчество</label>
                            </div>
                          </div>
                          {(inputValues.patronymic.indexOf(' ') > 0 || inputValues.patronymic.lastIndexOf(' ') > 0) && <span className={styles.span__error}>Содержит пробел</span>}
                        </div>
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          className={styles.filterSelect}
                          value={inputValues.type.label || ''}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'type')
                          }
                          options={typeOptions}
                          placeholder={inputValues.type.label || 'Выбрать'}
                          name='type'
                          span='Тип'
                        />
                      </div>
                    </div>

                    <div className={styles.checkbox__container}>
                      <input
                        onChange={handleCheckboxChange}
                        name='recipient'
                        disabled={inputValues.type.value !== 'main'}
                        type='checkbox'
                        checked={isCheckboxesChecked}
                      />
                      <label>Получатель другой</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('login') && styles.error)}>
                        <input
                          value={id ? `${inputValues.id}${inputValues.surname}` : ''}
                          onChange={handleInputChange}
                          name='login'
                          type='text'
                          placeholder=' '
                        />
                        <label>Логин<span className={styles.changed}>*</span></label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('password') && styles.error)}>
                        <input
                          onChange={handleInputChange}
                          name='password'
                          type='password'
                          placeholder=' '
                        />
                        <label>Пароль<span className={styles.changed}>*</span></label>
                      </div>
                    </div>

                    <div className='add__photo_wrapper'>
                      <div className={styles.photo__block}>
                        <span>Фото</span>
                        <div className='add__photo_elem'>
                          <input
                            className='download__file_input'
                            onChange={() => { }}
                            placeholder='Загрузить'
                            disabled={inputValues.type.value !== 'main'}
                            type='file'
                            name='file'
                            id='file'
                          />
                          <label htmlFor='file' className='file__label' onClick={() => { }}>
                            Загрузить
                          </label>
                        </div>
                        <div className='add__photo_elem'>
                          <input
                            className='download__file_input'
                            onChange={() => { }}
                            placeholder='Сделать'
                            type='file'
                            name='file'
                            id='file'
                            disabled={inputValues.type.value !== 'main'}
                          />
                          <label htmlFor='file' className={clsx('file__label', 'file__label_yellow')} onClick={() => { }}>
                            Сделать
                          </label>
                        </div>
                      </div>
                    </div>

                    <TextArea
                      inputValues={[]}
                      handleInputChange={handleInputChange}
                      name='comment'
                      title='Комментарий'
                      data={[]}
                    />

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <div className={clsx(styles.filterInput, errors.includes('advertisingCategory') && styles.error)}>
                          <Select
                            className={styles.filterSelect}
                            value={advertisingCategories}
                            isShowPlaceholder={true}
                            propsChange={(event: {value: string, label: string}) =>
                              selectChange(event, 'advertisingCategory')
                            }
                            options={[]}
                            placeholder={inputValues.type.label || 'Выбрать'}
                            name='advertisingCategory'
                            span='Категория рекламы'
                          />
                        </div>
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <div className={clsx(styles.filterInput, errors.includes('advertisingSource') && styles.error)}>
                          <Select
                            className={styles.filterSelect}
                            value={advertisingSources}
                            isShowPlaceholder={true}
                            propsChange={(event: {value: string, label: string}) =>
                              selectChange(event, 'advertisingSource')
                            }
                            options={[]}
                            placeholder={inputValues.type.label || 'Выбрать'}
                            name='advertisingSource'
                            span='Источник рекламы'
                          />
                        </div>
                      </div>
                    </div>
                  </>}
                />

                <Accardion
                  name='dates'
                  title='Даты'
                  children={<><div className={clsx(
                    styles.subBlock,
                    styles.subBlock__right,
                    styles.filterInput,
                  )}>
                    <input
                      value={id && createData}
                      name='createdApplicationDate'
                      type='text'
                      disabled={true}
                    />
                    <label>Дата создания анкеты</label>
                  </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <input
                        value={id && createData}
                        name='createdDate'
                        type='text'
                        disabled={true}
                      />
                      <label>Создан</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <input
                        value={id && createData}
                        name='internshipDate'
                        type='text'
                        disabled={true}
                      />
                      <label>Дата направления на стажировку</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <input
                        value={id ? createData : ''}
                        name='startWorkedDate'
                        type='text'
                        disabled={true}
                      />
                      <label>Дата начала работы</label>
                    </div>
                    {id && <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <span className='section__title'>История</span>
                      <div className={styles.history}>
                        <p>Восстановлен сотрудником 79019Лабутин в 14/12/2023 12:55.</p>
                        <p>Уволен сотрудником 79019Лабутин в 14/12/2023 12:55.</p>
                        <p>Причина увольнения: По собственному желанию.</p>
                        <p>Комментарий: тест.</p>
                      </div>
                    </div>}</>}
                />

                <Accardion
                  name='contacts'
                  title='Контакты'
                  children={<>
                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='workPhone'
                        type='number'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Рабочий телефон</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        defaultValue={id ? inputValues.phone : ''}
                        onChange={handleInputChange}
                        name='personalPhone'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Личный телефон</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='email'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Электронная почта</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='emailAdditional'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Электронная почта(доп)</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='telegram'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Telegram</label>
                    </div>
                  </>}
                />

                <Accardion
                  name='infoProject'
                  title='Информация о проекте'
                  children={<>
                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          className={styles.filterSelect}
                          value={id ? { value: '', label: 'Мерчендайзер' } : undefined}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'role')
                          }
                          placeholder={!id && 'Выбрать'}
                          options={[]}
                          name='role'
                          span='Роль'
                        />
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          className={styles.filterSelect}
                          value={id ? { value: '', label: 'Мерчендайзер' } : undefined}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'position')
                          }
                          options={[]}
                          name='position'
                          span='Должность'
                          placeholder={!id && 'Выбрать'}
                        />
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          className={styles.filterSelect}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'namePm')
                          }
                          options={[]}
                          name='namePm'
                          span='ФИО руководителя'
                          value={id ? { value: '', label: 'Петров' } : undefined}
                          placeholder={!id && 'Выбрать'}
                        />
                      </div>
                    </div>

                    <div>
                      <div className='reports__region_block-select' style={{ margin: "15px 0 0 0" }}>
                        <CustomMultiSelect
                          setLoading={() => { }}
                          setState={() => { }}
                          reducer={() => { }}
                          inputValues={[]}
                          isShowPlaceholder={true}
                          placeholder='Проект'
                          name='project'
                          pageName='vacancy'
                          options={[{ value: '', label: '' }]}
                          action={() => { }}
                          resetPages={() => { }}
                          disabled={true}
                        />
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          options={[]}
                          className={clsx(styles.filterSelect)}
                          placeholder={'Выбрать'}
                          name='area'
                          span='Область'
                          isShowPlaceholder={true}
                        />
                      </div>
                    </div>

                    <div>
                      <div className='reports__region_block-select' style={{ margin: "15px 0 0 0" }}>
                        <CustomMultiSelect
                          setLoading={() => { }}
                          setState={() => { }}
                          reducer={() => { }}
                          inputValues={[]}
                          isShowPlaceholder={true}
                          placeholder='Супервайзер'
                          name='sv'
                          pageName='vacancy'
                          options={[]}
                          action={() => { }}
                          resetPages={() => { }}
                          disabled={true}
                        />
                      </div>
                    </div>

                    <div>
                      <div className='reports__region_block-select' style={{ margin: "15px 0 0 0" }}>
                        <CustomMultiSelect
                          setLoading={() => { }}
                          setState={() => { }}
                          reducer={() => { }}
                          inputValues={[]}
                          isShowPlaceholder={true}
                          placeholder='Виртуальные супервайзер'
                          name='vsv'
                          pageName='vacancy'
                          options={[]}
                          activeOptions={[]}
                          action={() => { }}
                          resetPages={() => { }}
                          disabled={true}
                        />
                      </div>
                    </div>

                    <div>
                      <div className='reports__region_block-select' style={{ margin: "15px 0 0 0" }}>
                        <CustomMultiSelect
                          setLoading={() => { }}
                          setState={() => { }}
                          reducer={() => { }}
                          inputValues={[]}
                          isShowPlaceholder={true}
                          placeholder='Руководитель проекта'
                          name='pm'
                          pageName='vacancy'
                          options={[]}
                          activeOptions={[]}
                          action={() => { }}
                          resetPages={() => { }}
                          disabled={true}
                        />
                      </div>
                    </div>

                    <div className={clsx(
                      styles.filterInput,
                      inputValues.role.value !== 'merchandiser' && styles.notVisible
                    )}>
                      <div className={styles.subBlock__right}>
                        <Select
                          className={styles.filterSelect}
                          value={id ? inputValues.role.value === 'merchandiser' ? { value: 'true', label: 'Да' } : '' : undefined}
                          isShowPlaceholder={true}
                          options={logOptions}
                          name='hasroute'
                          disabled={true}
                          span='Наличие маршрута'
                          placeholder={id ? inputValues.type.label : 'Выбрать'}
                        />
                      </div>
                    </div>

                    <div className={styles.subBlock__right} style={{ marginTop: "19px" }}>
                      <div className="filter__data_picker filter__data_picker-full">
                        <DatePicker
                          onChange={() => { }}
                          selected={null}
                          disabled={true}
                          dateFormat="dd.MM.yyyy"
                          placeholderText="Дата снятия с маршрута"
                          autoComplete="off"
                          locale={ru}
                          name="date"
                        />
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          className={styles.filterSelect}
                          isShowPlaceholder={true}
                          options={[]}
                          placeholder={'Выбрать'}
                          name='status'
                          disabled={true}
                          span='Статус'
                        />
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <input
                        defaultValue={7}
                        name='autoRemoveUnloading'
                        type='number'
                      />
                      <label>Автоудаление выгрузок, дней</label>
                    </div>

                    <div className={styles.checkbox__container}>
                      <input
                        name='shopWorker'
                        type='checkbox'
                      />
                      <label>Работник магазина</label>
                    </div>

                    <div className={styles.checkbox__container}>
                      <input
                        name='trotter'
                        type='checkbox'
                      />
                      <label>Троттер</label>
                    </div>

                    <div className={styles.checkbox__container}>
                      <input
                        name='freelance'
                        type='checkbox'
                      />
                      <label>Фрилансер</label>
                    </div>

                    <div className={styles.checkbox__container}>
                      <input
                        name='trainee'
                        type='checkbox'
                      />
                      <label>Стажёр</label>
                    </div>
                  </>}
                />

                {id && inputValues.fired.fired &&
                  <Accardion
                    name='infoFired'
                    title='Информация по увольнению'
                    children={<>
                      <div className={clsx(styles.filterInput, errors.includes('dateFired') && styles.error)} style={{ marginTop: "19px" }}>
                        <div className="filter__data_picker">
                          <DatePicker
                            onChange={() => { }}
                            onKeyDown={() => { }}
                            selected={inputValues?.fired?.date || new Date()}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Дата увольнения"
                            autoComplete="off"
                            locale={ru}
                            name="dateFired"
                          />
                          <label className={styles.labelDataPicker}>Дата увольнения</label>
                        </div>
                      </div>

                      <div className={styles.filterInput}>
                        <div className={styles.subBlock__right}>
                          <div className={clsx(styles.filterInput, errors.includes('reasonFired') && styles.error)}>
                            <Select
                              className={styles.filterSelect}
                              value={{ value: '', label: 'По собственному желанию' }}
                              isShowPlaceholder={true}
                              propsChange={(event: {value: string, label: string}) =>
                                selectChange(event, 'reasonFired')
                              }
                              options={[{ value: '', label: 'По собственному желанию' }]}
                              placeholder={inputValues.type.label || 'Выбрать'}
                              name='reasonFired'
                              disabled={false}
                              span='Причина увольнения'
                            />
                          </div>
                        </div>
                      </div>

                      <TextArea
                        inputValues={[]}
                        handleInputChange={handleInputChange}
                        name='commentFired'
                        title='Комментарий к увольнению'
                        data={[]}
                      />

                      <div className={clsx(
                        styles.subBlock,
                        styles.subBlock__right,
                        styles.filterInput,
                      )}>
                        <input
                          value={createData}
                          name='dateFired'
                          type='text'
                          onChange={() => { }}
                          disabled={true}
                        />
                        <label>Дата проведения увольнения</label>
                      </div>

                      <div className={clsx(
                        styles.filterInput,
                        errors.includes('whomFired') && styles.error
                      )}>
                        <div className={styles.subBlock__right}>
                          <Select
                            className={styles.filterSelect}
                            value={{ value: '', label: 'Мартынова' }}
                            isShowPlaceholder={true}
                            options={[{ value: '', label: 'Мартынова' }]}
                            placeholder={inputValues.type.label || 'Выбрать'}
                            name='whomFired'
                            disabled={true}
                            span='Кем уволен'
                          />
                        </div>
                      </div></>}
                  />}

                {id && inputValues.blocked &&
                  <Accardion
                    name='infoBlocked'
                    title='Информация по блокировке'
                    children={<>

                      <TextArea
                        inputValues={[]}
                        handleInputChange={handleInputChange}
                        name='reasonBlocking'
                        title='Причина блокировки'
                        data={[]}
                        error={errors.includes('reasonBlocking')}
                      />

                      <div className={clsx(
                        styles.subBlock,
                        styles.subBlock__right,
                        styles.filterInput,
                      )}>
                        <input
                          value={id && createData}
                          name='dateBlocking'
                          type='text'
                          onChange={() => { }}
                          disabled={true}
                        />
                        <label>Дата блокировки</label>
                      </div>
                      <div className={clsx(
                        styles.filterInput,
                        errors.includes('whomFired') && styles.error
                      )}>
                        <div className={styles.subBlock__right}>
                          <Select
                            className={styles.filterSelect}
                            value={id ? { value: '', label: 'Мартынова' } : undefined}
                            isShowPlaceholder={true}
                            options={[{ value: '', label: 'Мартынова' }]}
                            placeholder={id ? inputValues.type.label : 'Выбрать'}
                            name='whomBlocking'
                            disabled={true}
                            span='Кем заблокирован'
                          />
                        </div>
                      </div>
                    </>}
                  />}

                <Accardion
                  name='migrationCard'
                  title='Миграционная карта'
                  children={<>

                    <TextArea
                      inputValues={[]}
                      handleInputChange={handleInputChange}
                      name='dataMigrationCard'
                      title='Данные'
                      data={[]}
                    />

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'dateIssueMigration' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Дата выдачи"
                            autoComplete="off"
                            locale={ru}
                            name="dateIssueMigration"
                            onCalendarOpen={() => setIsOpenDatePicker("dateIssueMigration")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'expirationDateMigration' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Срок окончания"
                            autoComplete="off"
                            locale={ru}
                            name="expirationDateMigration"
                            onCalendarOpen={() => setIsOpenDatePicker("expirationDateMigration")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={styles.subBlock}>
                      <div className={styles.subBlock__left}>
                        <span className={styles.subBlock__left__text}>Скан</span>
                      </div>
                      <div className='add__photo_wrapper'>
                        <div className={styles.photo__block}>
                          {(!isVisibleScanMigration && inputValues.type.value === 'main') && <div className='add__photo_elem'>
                            <input
                              className='download__file_input'
                              onChange={() => { }}
                              placeholder='Загрузить'
                              disabled={inputValues.type.value !== 'main'}
                              type='file'
                              name='scanfile'
                              id='file'
                            />
                            <label htmlFor='file' className='file__label' onClick={() => { }}>
                              Загрузить
                            </label>
                          </div>}
                          {isVisibleScanMigration && <div className={styles.photo} >
                            <div className={styles.photo__container} />
                            <button disabled={inputValues.type.value !== 'main'} className={styles.photo__remove} onClick={() => setIsVisibleScanMigration(false)}></button>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </>}
                />

                <Accardion
                  name='patentWork'
                  title='Патент на работу'
                  children={<>
                    <div className={styles.subBlock}>
                      <div className={styles.subBlock__right}>
                        <div className={styles.filterInput}>
                          <input
                            disabled={inputValues.type.value !== 'main'}
                            name='number'
                            type='text'
                            placeholder='Номер'
                          />
                          <label>Номер</label>
                        </div>
                      </div>
                    </div>

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'dateIssuePatent' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Дата выдачи"
                            autoComplete="off"
                            locale={ru}
                            name="dateIssuePatent"
                            onCalendarOpen={() => setIsOpenDatePicker("dateIssuePatent")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'expirationDatePatent' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Срок окончания"
                            autoComplete="off"
                            locale={ru}
                            name="expirationDatePatent"
                            onCalendarOpen={() => setIsOpenDatePicker("expirationDatePatent")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={styles.textareaContainer}>
                      <TextArea
                        inputValues={[]}
                        handleInputChange={handleInputChange}
                        name='dataMigrationCard'
                        title='Кем выдан'
                        data={[]}
                      />
                    </div>

                    <div className={styles.subBlock}>
                      <div className={styles.subBlock__left}>
                        <span className={styles.subBlock__left__text}>Скан</span>
                      </div>
                      <div className='add__photo_wrapper'>
                        <div className={styles.photo__block}>
                          {(!isVisibleScanPatent && inputValues.type.value === 'main') && <div className='add__photo_elem'>
                            <input
                              className='download__file_input'
                              onChange={() => { }}
                              placeholder='Загрузить'
                              type='file'
                              name='scanfile'
                              disabled={inputValues.type.value !== 'main'}
                              id='file'
                            />
                            <label htmlFor='file' className='file__label' onClick={() => { }}>
                              Загрузить
                            </label>
                          </div>}
                          {isVisibleScanPatent && <div className={styles.photo} >
                            <div className={styles.photo__container} />
                            <button disabled={inputValues.type.value !== 'main'} className={styles.photo__remove} onClick={() => setIsVisibleScanPatent(false)}></button>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </>}
                />

                <Accardion
                  name='medBook'
                  title='Медицинская книжка'
                  children={<>

                    <TextArea
                      inputValues={[]}
                      handleInputChange={handleInputChange}
                      name='dataMed'
                      title='Данные'
                      data={[]}
                    />

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'dateIssueMedical' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Дата выдачи"
                            autoComplete="off"
                            locale={ru}
                            name="dateIssueMedical"
                            onCalendarOpen={() => setIsOpenDatePicker("dateIssueMedical")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'expirationDateMedical' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Срок окончания"
                            autoComplete="off"
                            locale={ru}
                            name="expirationDateMedical"
                            onCalendarOpen={() => setIsOpenDatePicker("expirationDateMedical")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={styles.subBlock}>
                      <div className={clsx(styles.subBlock__left, styles.subBlock__left_scan)}>
                        <span className={styles.subBlock__left__text}>Скан</span>
                      </div>
                      <div className='add__photo_wrapper'>
                        <div className={styles.photo__block}>
                          {(!isVisibleScanMed && inputValues.type.value === 'main') && <div className='add__photo_elem'>
                            <input
                              className='download__file_input'
                              onChange={() => { }}
                              placeholder='Загрузить'
                              type='file'
                              name='scanfile'
                              id='file'
                              disabled={inputValues.type.value !== 'main'}
                            />
                            <label htmlFor='file' className='file__label' onClick={() => { }}>
                              Загрузить
                            </label>
                          </div>}
                          {isVisibleScanMed && <div className={styles.photo} >
                            <div className={styles.photo__container} />
                            <button disabled={inputValues.type.value !== 'main'} className={styles.photo__remove} onClick={() => setIsVisibleScanMed(false)}></button>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </>}
                />
              </div>
            </div>
          </div>

          <div className={styles.midSectionWrapper}>
            <div className={styles.halfBlock}>
              <div className={styles.vacancyBlock}>
                <Accardion
                  name='recipient'
                  title='Получатель'
                  children={
                    <>
                      <div>
                        <div className={clsx(
                          styles.subBlock,
                          styles.subBlock__right,
                          styles.filterInput
                        )}>
                          <div className={clsx(styles.filterInput, errors.includes('surname') && styles.error)}>
                            <input
                              defaultValue={id ? inputValues.recipient.surname : ''}
                              onChange={handleInputChange}
                              name='surname'
                              type='text'
                              placeholder=' '
                              disabled={!isCheckboxesChecked}
                            />
                            <label>Фамилия получателя{isCheckboxesChecked && <span className={styles.changed}>*</span>}</label>
                          </div>
                        </div>
                        {(inputValues.recipient.surname.indexOf(' ') > 0 || inputValues.recipient.surname.lastIndexOf(' ') > 0) && <span className={styles.span__error}>Содержит пробел</span>}
                      </div>

                      <div>
                        <div className={clsx(
                          styles.subBlock,
                          styles.subBlock__right,
                          styles.filterInput
                        )}>
                          <div className={clsx(styles.filterInput, errors.includes('name') && styles.error)}>
                            <input
                              defaultValue={id ? inputValues.recipient.name : ''}
                              onChange={handleInputChange}
                              name='name'
                              type='text'
                              placeholder=' '
                              disabled={!isCheckboxesChecked}
                            />
                            <label>Имя получателя{isCheckboxesChecked && <span className={styles.changed}>*</span>}</label>
                          </div>
                        </div>
                        {(inputValues.recipient.name.indexOf(' ') > 0 || inputValues.recipient.name.lastIndexOf(' ') > 0) && <span className={styles.span__error}>Содержит пробел</span>}
                      </div>

                      <div>
                        <div className={clsx(
                          styles.subBlock,
                          styles.subBlock__right,
                          styles.filterInput
                        )}>
                          <div className={clsx(styles.filterInput)}>
                            <input
                              defaultValue={id ? inputValues.recipient.patronymic : ''}
                              onChange={handleInputChange}
                              name='patronymic'
                              type='text'
                              placeholder=' '
                              disabled={!isCheckboxesChecked}
                            />
                            <label>Отчество получателя</label>
                          </div>
                        </div>
                        {id && (inputValues.recipient.patronymic.indexOf(' ') > 0 || inputValues.recipient.patronymic.lastIndexOf(' ') > 0) && <span className={styles.span__error}>Содержит пробел</span>}
                      </div>

                      <div className={styles.subBlock__right} style={{ marginTop: "19px" }}>
                        <div className="filter__data_picker filter__data_picker-full">
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Дата рождения"
                            autoComplete="off"
                            locale={ru}
                            name="date"
                          />
                        </div>
                      </div>

                      <div>
                        <div className={clsx(
                          styles.subBlock,
                          styles.subBlock__right,
                          styles.filterInput
                        )}>
                          <div className={clsx(styles.filterInput)}>
                            <input
                              defaultValue={id ? inputValues.recipient?.birthplace : ''}
                              onChange={handleInputChange}
                              name='birthplace'
                              type='text'
                              placeholder=' '
                              disabled={inputValues.type.value !== 'main'}
                            />
                            <label>Место рождения</label>
                          </div>
                        </div>
                      </div>

                      <div className={styles.filterInput}>
                        <div className={styles.subBlock__right}>
                          <Select
                            className={styles.filterSelect}
                            value={id ? inputValues.recipient.gender : 'Мужской'}
                            isShowPlaceholder={true}
                            propsChange={(event: {value: string, label: string}) =>
                              selectChange(event, 'gender')
                            }
                            options={[{ value: 'male', label: 'Мужской' }, { value: 'female', label: 'Женский' }]}
                            placeholder={inputValues.type.label || 'Выбрать'}
                            name='gender'
                            span='Пол'
                            disabled={inputValues.type.value !== 'main'}
                          />
                        </div>
                      </div></>
                  }
                />

                <Accardion
                  name='requisites'
                  title='Банковские реквезиты'
                  children={
                    <>
                      <div className={clsx(
                        styles.subBlock,
                        styles.subBlock__right,
                        styles.filterInput
                      )}>
                        <div className={clsx(styles.filterInput)}>
                          <input
                            defaultValue={id ? `${inputValues.recipient.surname} ${inputValues.recipient.name} ${inputValues.recipient.patronymic}` : ''}
                            onChange={handleInputChange}
                            name='surname'
                            type='text'
                            placeholder=' '
                            disabled={true}
                          />
                          <label>ФИО получателя</label>
                        </div>
                      </div>

                      <div className={clsx(
                        styles.subBlock,
                        styles.subBlock__right,
                        styles.filterInput
                      )}>
                        <div className={clsx(styles.filterInput)}>
                          <InputMask
                            mask='999999999'
                            onChange={handleInputChange}
                            maskChar='X'
                            name='bik'
                            placeholder={' '}
                            type='text'
                            disabled={inputValues.type.value !== 'main'}
                          />
                          <label>БИК</label>
                        </div>
                      </div>

                      <div className={clsx(
                        styles.subBlock,
                        styles.subBlock__right,
                        styles.filterInput
                      )}>
                        <div className={clsx(styles.filterInput)}>
                          <input
                            onChange={handleInputChange}
                            name='accountNumber'
                            type='number'
                            placeholder=' '
                            disabled={inputValues.type.value !== 'main'}
                          />
                          <label>Номер счёта</label>
                        </div>
                      </div>

                      <div className={clsx(
                        styles.subBlock,
                        styles.subBlock__right,
                        styles.filterInput
                      )}>
                        <div className={clsx(styles.filterInput)}>
                          <input
                            onChange={handleInputChange}
                            name='cardNumber'
                            type='number'
                            placeholder=' '
                            maxLength={20}
                            disabled={inputValues.type.value !== 'main'}
                          />
                          <label>Номер карты</label>
                        </div>
                      </div>

                      <div className={styles.subBlock__right} style={{ marginTop: "19px" }}>
                        <div className="filter__data_picker filter__data_picker-full" style={{ width: "100%" }}>
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            disabled={inputValues.type.value !== 'main'}
                            dateFormat="MM.yyyy"
                            placeholderText="Дата окончания действия карты"
                            autoComplete="off"
                            locale={ru}
                            name="date"
                          />
                        </div>
                      </div>
                    </>
                  }
                />

                <Accardion
                  name='passportDetails'
                  title='Паспортные данные'
                  children={<>
                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          disabled={inputValues.type.value !== 'main'}
                          className={styles.filterSelect}
                          value={{ label: 'Паспорт РФ', value: 'Паспорт РФ' }}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'gender')
                          }
                          options={[{ label: 'Паспорт РФ', value: 'Паспорт РФ' }]}
                          placeholder={inputValues.type.label || 'Выбрать'}
                          name='typeDocument'
                          span='Тип документа'
                        />
                      </div>
                    </div>

                    <div className={styles.checkbox__container} style={{ marginBottom: "5px", marginTop: "5px" }}>
                      <input
                        onChange={handleCheckboxChange}
                        name='commonwealth'
                        disabled={inputValues.type.value !== 'main'}
                        type='checkbox'
                      />
                      <label>Содружество</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <input
                          onChange={handleInputChange}
                          name='document'
                          type='text'
                          placeholder=' '
                          disabled={true}
                        />
                        <label>Документ</label>
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          disabled={inputValues.type.value !== 'main'}
                          className={styles.filterSelect}
                          value={{ label: 'Россия', value: 'ru' }}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'citizenship')
                          }
                          options={[{ label: 'Россия', value: 'ru' }]}
                          placeholder={inputValues.type.label || 'Выбрать'}
                          name='typeDocument'
                          span='Гражданство'
                        />
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <InputMask
                          mask='99999999999'
                          onChange={handleInputChange}
                          maskChar='X'
                          name='snils'
                          placeholder={' '}
                          type='text'
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>СНИЛС</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <InputMask
                          mask='999999999999'
                          onChange={handleInputChange}
                          maskChar='X'
                          name='inn'
                          placeholder={' '}
                          type='text'
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>ИНН</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <input
                          onChange={handleInputChange}
                          name='numberDoc'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Номер</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <input
                          onChange={handleInputChange}
                          name='issuedDoc'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Выдан</label>
                      </div>
                    </div>

                    <div className={styles.subBlock__right} style={{ marginTop: "19px" }}>
                      <div className="filter__data_picker filter__data_picker-full" style={{ width: "100%" }}>
                        <DatePicker
                          onChange={() => { }}
                          selected={null}
                          dateFormat="dd.MM.yyyy"
                          placeholderText="Дата выдачи"
                          autoComplete="off"
                          locale={ru}
                          name="date"
                          disabled={inputValues.type.value !== 'main'}
                        />
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <input
                          onChange={handleInputChange}
                          name='department'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Код подразделения</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <div className={clsx(styles.filterInput)}>
                        <input
                          onChange={handleInputChange}
                          name='registration'
                          type='text'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Постоянная регистрация</label>
                      </div>
                    </div>

                    <div className={styles.subBlock}>
                      <div className={clsx(styles.subBlock__left, styles.subBlock__left_scan)}>
                        <span className={styles.subBlock__left__text}>Скан</span>
                        {inputValues.type.value === 'main' && <div className='add__photo_elem'>
                          <input
                            className='download__file_input'
                            onChange={() => { }}
                            placeholder='Загрузить'
                            type='file'
                            name='scanfile'
                            id='file'
                            multiple
                            disabled={inputValues.type.value !== 'main'}
                          />
                          <label htmlFor='file' className='file__label' onClick={() => { }}>
                            Загрузить
                          </label>
                        </div>}
                      </div>
                      {id && <div className={styles.scan}>
                        <div className={styles.scan_wrapper}>

                          <div className={clsx(styles.halfBlock, 'history_title')}>
                            <table className={styles.table__scan}>
                              <thead style={{ top: '-1px' }}>
                                <tr>
                                  <th>Название</th>
                                  <th>Описание</th>
                                  <th>Тип</th>
                                  <th>Дата создания</th>
                                  <th>Создал</th>
                                  <th style={{ width: '50px' }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {[0, 1, 3, 4, 5, 6, 7, 8].map((el: number, index: number) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <tr key={index}>
                                        <td>111</td>
                                        <td>
                                          <input
                                            defaultValue={'aaa'}
                                            onChange={handleInputChange}
                                            name='description'
                                            type='text'
                                            placeholder=' '
                                            disabled={inputValues.type.value !== 'main'}
                                          />
                                        </td>
                                        <td>Фаил</td>
                                        <td>21.06.2024 12:55</td>
                                        <td>555</td>
                                        <td style={{ position: 'relative' }}>
                                          <button disabled={inputValues.type.value !== 'main'} className={clsx(styles.photo__remove, styles.photo__remove_file)}></button>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>}
                    </div>
                  </>}
                />

                <Accardion
                  name='contactRecipient'
                  title='Контакты получателя'
                  children={<>
                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='workPhone'
                        type='number'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Рабочий телефон</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='personalPhone'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Личный телефон</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='email'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Электронная почта</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='emailAdditional'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Электронная почта(доп)</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='telegram'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Telegram</label>
                    </div>
                  </>}
                />

                <Accardion
                  name='infoStructuralUnit'
                  title='Информация о структурном подразделении'
                  children={<>
                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          disabled={inputValues.type.value !== 'main'}
                          className={styles.filterSelect}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'control')
                          }
                          options={[]}
                          placeholder={'Выбрать'}
                          name='control'
                          span='Управление'
                        />
                      </div>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          disabled={inputValues.type.value !== 'main'}
                          className={styles.filterSelect}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'service')
                          }
                          options={[]}
                          placeholder={'Выбрать'}
                          name='service'
                          span='Служба'
                        />
                      </div>
                    </div>
                  </>}
                />

                <Accardion
                  name='infoWorkCompani'
                  title='Информация о работе компании'
                  children={<>
                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='organization'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Организация</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='contractNumber'
                        type='text'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Номер договора</label>
                    </div>

                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          disabled={inputValues.type.value !== 'main'}
                          className={styles.filterSelect}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'service')
                          }
                          options={[{ value: 0, label: '0' }]}
                          value={{ value: 0, label: '0' }}
                          placeholder={'Выбрать'}
                          name='graide'
                          span='Грейд'
                        />
                      </div>
                    </div>

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'dateRegistrationTK' && styles.subBlock__datapicker)}>
                      <div className="filter__data_picker filter__data_picker-full" style={{ width: "100%" }}>
                        <DatePicker
                          onChange={() => { }}
                          selected={null}
                          dateFormat="dd.MM.yyyy"
                          placeholderText="Дата оформления по ТК"
                          autoComplete="off"
                          locale={ru}
                          name="dateRegistrationTK"
                          disabled={inputValues.type.value !== 'main'}
                          onCalendarOpen={() => setIsOpenDatePicker("dateRegistrationTK")}
                          onCalendarClose={() => setIsOpenDatePicker('')}
                        />
                      </div>
                    </div>

                    <div className={clsx(styles.subBlock, isOpenDatePicker === 'expirationDatePatent' && styles.subBlock__datapicker)}>
                      <div className={styles.subBlock__right}>
                        <div className="filter__data_picker filter__data_picker-full" style={{ width: "100%" }}>
                          <DatePicker
                            onChange={() => { }}
                            selected={null}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="Дата расторжения"
                            autoComplete="off"
                            locale={ru}
                            name="dateTermination"
                            disabled={inputValues.type.value !== 'main'}
                            onCalendarOpen={() => setIsOpenDatePicker("dateTermination")}
                            onCalendarClose={() => setIsOpenDatePicker('')}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='numberDDM'
                        type='number'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Номер ДММ</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='numberDDM'
                        type='number'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Номер ЦЦП</label>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput
                    )}>
                      <input
                        onChange={handleInputChange}
                        name='numberZMP'
                        type='number'
                        placeholder=' '
                        disabled={inputValues.type.value !== 'main'}
                      />
                      <label>Номер ЦМР</label>
                    </div>
                  </>}
                />

                <Accardion
                  name='infoPayments'
                  title='Информация о выплатах'
                  children={<>
                    <div className={styles.filterInput}>
                      <div className={styles.subBlock__right}>
                        <Select
                          disabled={inputValues.type.value !== 'main'}
                          className={styles.filterSelect}
                          isShowPlaceholder={true}
                          propsChange={(event: {value: string, label: string}) =>
                            selectChange(event, 'salatyType')
                          }
                          options={[{ label: 'Сдельная', value: 'piecework' }]}
                          value={{ label: 'Сдельная', value: 'piecework' }}
                          placeholder={'Выбрать'}
                          name='salatyType'
                          span='Тип зарплаты'
                        />
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('salary') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='salary'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Оклад</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('additionalPayments') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='additionalPayments'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Дополнительные выплаты</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('costPerHour') && styles.error)}>
                        <InputNumber
                          handleInputChange={handleInputChange}
                          reducer={reducerTest}
                          inputValues={inputTest}
                          editVacancy={true}
                          name="costPerHour"
                          styleName="limit__input"
                          style={{ margin: '0' }}
                        />
                        <label>Стоимость часа</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('bonus1') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='bonus1'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Бонус 1</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('bonus2') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='bonus2'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Бонус 2</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('bonus3') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='bonus3'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Бонус 3</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('avto') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='avto'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Компенсация авто</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('communicationCompensation') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='communicationCompensation'
                          type='number'
                          placeholder=' '
                          disabled={inputValues.type.value !== 'main'}
                        />
                        <label>Компенсация связи</label>
                      </div>
                    </div>

                    <div className={clsx(
                      styles.subBlock,
                      styles.subBlock__right,
                      styles.filterInput,
                    )}>
                      <div className={clsx(styles.filterInput, errors.includes('total') && styles.error)}>
                        <input
                          defaultValue={0}
                          onChange={handleInputChange}
                          name='total'
                          type='number'
                          placeholder=' '
                          disabled={true}
                        />
                        <label>Итого</label>
                      </div>
                    </div>

                    <div className={styles.subBlock}>
                      <div className={clsx(styles.subBlock__left, styles.subBlock__left_scan)}>
                        <span className={styles.subBlock__left__text}>Скан</span>
                        {inputValues.type.value === 'main' && <div className='add__photo_elem'>
                          <input
                            className='download__file_input'
                            onChange={() => { }}
                            placeholder='Загрузить'
                            type='file'
                            name='scanfile'
                            id='file'
                            multiple
                            disabled={inputValues.type.value !== 'main'}
                          />
                          <label htmlFor='file' className='file__label' onClick={() => { }}>
                            Загрузить
                          </label>
                        </div>}
                      </div>
                      {id && <div className={styles.scan}>
                        <div className={styles.scan_wrapper}>
                          <div className={clsx(styles.halfBlock, 'history_title')}>
                            <table className={styles.table__scan}>
                              <thead style={{ top: '-1px' }}>
                                <tr>
                                  <th>Название</th>
                                  <th>Описание</th>
                                  <th>Тип</th>
                                  <th>Дата создания</th>
                                  <th>Создал</th>
                                  <th style={{ width: '50px' }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {[0, 1, 3, 4, 5, 6, 7, 8].map((el: number, index: number) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <tr key={index}>
                                        <td>111</td>
                                        <td>
                                          <input
                                            defaultValue={'aaa'}
                                            onChange={handleInputChange}
                                            name='description'
                                            type='text'
                                            placeholder=' '
                                            disabled={inputValues.type.value !== 'main'}
                                          />
                                        </td>
                                        <td>Фаил</td>
                                        <td>21.06.2024 12:55</td>
                                        <td>555</td>
                                        <td style={{ position: 'relative' }}>
                                          <button disabled={inputValues.type.value !== 'main'} className={clsx(styles.photo__remove, styles.photo__remove_file)}></button>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>}
                    </div>
                  </>}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableProfileEmplooyee;